import { render, staticRenderFns } from "./UploadOverlayButton.vue?vue&type=template&id=28f2921c&scoped=true"
import script from "./UploadOverlayButton.vue?vue&type=script&lang=js"
export * from "./UploadOverlayButton.vue?vue&type=script&lang=js"
import style0 from "./UploadOverlayButton.vue?vue&type=style&index=0&id=28f2921c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2921c",
  null
  
)

export default component.exports